import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import CommentInputCreate from "../PostsList/components/Interactions/components/CommentInput/CommentInputCreate";
import PostHeader from "./Components/PostHeader";
import PostContent from "./Components/PostContent";
import PostImages from "./Components/PostImages";
import Interactions from "../PostsList/components/Interactions";
import RecommendedPosts from "../RecommendedPosts";

import "./index.css";

class Post extends Component {
  constructor(props) {
    super(props);

    this.state = {
      desktopCommentInputRef: null,
    };
  }

  componentDidMount() {
    this.desktopCommentInputRef.focus();
    this.setState({
      desktopCommentInputRef: this.desktopCommentInputRef,
    });
  }

  componentDidUpdate(prevProps) {
    // If a new comment is just posted, scroll it into view
    if (prevProps.post.comments.pending.length < this.props.post.comments.pending.length) {
      this.desktopCommentsList.scrollTop = 1000000;
    }
  }

  static propTypes = {
    post: PropTypes.object.isRequired,
    animationClass: PropTypes.string,
  };

  getPostImages(post) {
    return post.images.map(image => {
      return { ...image, src: image.url };
    });
  }

  render() {
    const post = this.props.post;
    const postImages = this.getPostImages(post);
    const { recommendedPostsAnimationClass = "", animationClass = "", container = "" } = this.props;

    if (Object.keys(post).length === 0) {
      return (
        <div>
          <h1>Nothing to view here </h1>
        </div>
      );
    }
    return (
      <div>
        <div className={`post-wrapper ${animationClass}`}>
          <Grid stackable>
            <Grid.Column width={10}>
              <article className="-content-wrapper -mobile">
                <PostHeader post={post} closeModal={this.props.closeModal} container={container} />
                <PostContent post={post} />
                <br />
              </article>
              <PostImages postImages={postImages} />
            </Grid.Column>
            <Grid.Column width={6} className="-side-bar">
              <article className="-content-wrapper -desktop" ref={article => (this.desktopCommentsList = article)}>
                <PostHeader post={post} closeModal={this.props.closeModal} container={container} />
                <PostContent post={post} />
                <Interactions desktopCommentInputRef={this.state.desktopCommentInputRef} />
              </article>
              <CommentInputCreate className="-desktop" getInputRef={input => (this.desktopCommentInputRef = input)} />
            </Grid.Column>
          </Grid>
        </div>
        <div className={`recommended-posts-wrapper ${recommendedPostsAnimationClass}`}>
          {this.props.post.similarPosts.posts.length > 0 && (
            <RecommendedPosts container={container} post={this.props.post} />
          )}
        </div>
      </div>
    );
  }
}

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post/index.js